/**
 * Автоперевод браузера (Chrome, Google Translate) подменяет текстовые узлы своими `<font>`.
 * React при следующем обновлении вставляет и удаляет узлы относительно прежних, которых в
 * DOM уже нет, падает на `insertBefore`/`removeChild` — и весь экран пустеет (ckycn: Android,
 * страница переведена на английский, первая буква в заголовке инструкции).
 *
 * Чужой узел не трогаем: удалить его нельзя — он уже вынут, вставить перед ним — значит в
 * конец. Цена — переведённый текст на этом месте может не обновиться, но страница жива.
 */
export const installTranslateDomGuard = (): void => {
  if (typeof Node !== 'function') return
  const proto = Node.prototype
  const removeChild = proto.removeChild
  proto.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      console.warn('[translateDomGuard] removeChild: узел не дочерний', child)
      return child
    }
    return removeChild.call(this, child) as T
  }
  const insertBefore = proto.insertBefore
  proto.insertBefore = function <T extends Node>(this: Node, node: T, ref: Node | null): T {
    if (ref && ref.parentNode !== this) {
      console.warn('[translateDomGuard] insertBefore: ref не дочерний', ref)
      return insertBefore.call(this, node, null) as T
    }
    return insertBefore.call(this, node, ref) as T
  }
}
